import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const faqItems = [
  {
    question: '麻将在线玩需要下载安装吗？',
    answer: '完全不需要！麻将在线玩是纯网页版麻将平台，打开浏览器即可开始游戏，无需下载任何软件或App。我们采用先进的HTML5技术，确保在电脑、手机、平板等所有设备上都能流畅运行。',
  },
  {
    question: '在线麻将支持哪些玩法？',
    answer: '我们目前支持国标麻将、四川麻将（血战到底）、广东麻将（鸡平胡、推倒胡）等多种主流玩法。每种玩法都有详细的规则说明，新手也能快速上手。我们会持续更新更多地方麻将玩法。',
  },
  {
    question: '如何开始一局在线麻将？',
    answer: '进入平台后，选择你喜欢的麻将玩法，系统会自动为你匹配水平相近的在线玩家。你也可以创建私人房间，邀请好友一起对战。匹配速度很快，通常在10秒内就能找到对手。',
  },
  {
    question: '在线麻将如何保证公平性？',
    answer: '我们的平台采用随机发牌算法，经过第三方机构认证，确保每一局游戏绝对公平。同时，系统内置反作弊机制，实时监控异常行为，为所有玩家营造公平公正的游戏环境。',
  },
  {
    question: '手机玩麻将会不会很卡？',
    answer: '我们针对移动端做了深度优化，采用轻量级渲染引擎，即使在4G网络下也能流畅运行。界面设计充分适配手机屏幕，触控操作灵敏精准，给你媲美原生App的游戏体验。',
  },
  {
    question: '可以邀请好友一起玩吗？',
    answer: '当然可以！在平台创建私人房间后，将房间号分享给好友即可一起对战。支持语音聊天功能，让你和好友边打麻将边聊天，享受如同线下聚会的乐趣。',
  },
];

export default function FAQSection() {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            {t('faq.title')}
          </h2>
          <p className="text-sm text-foreground-500">
            关于麻将在线玩的常见问题解答
          </p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item, index) => (
            <div
              key={index}
              className="bg-background-50 border border-background-200/70 rounded-lg overflow-hidden"
            >
              <button
                onClick={() => toggle(index)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
              >
                <span className="text-sm md:text-base font-medium text-foreground-800 pr-4">
                  {item.question}
                </span>
                <span className={`w-5 h-5 flex items-center justify-center flex-shrink-0 transition-transform duration-200 ${openIndex === index ? 'rotate-45' : ''}`}>
                  <i className="ri-add-line text-foreground-500"></i>
                </span>
              </button>
              {openIndex === index && (
                <div className="px-5 pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {item.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}